import { FactoryIcon } from 'lucide-react'
import { getAssetUrl } from '@/config/assetUrl'

type PropsT = {
  logosrc: string | null | undefined
}
export default function OrgAvatar({ logosrc }: PropsT) {
  if (logosrc)
    return (
      <img className={`size-5 rounded-full`} alt={`logo`} height={20} width={20} src={getAssetUrl(logosrc)} />
    )

  return <FactoryIcon className={`mb-[1px] size-4`} />
}
